import { render, staticRenderFns } from "./BankAccounts.vue?vue&type=template&id=78e00fbd&scoped=true"
import script from "./BankAccounts.vue?vue&type=script&lang=js"
export * from "./BankAccounts.vue?vue&type=script&lang=js"
import style0 from "./BankAccounts.vue?vue&type=style&index=0&id=78e00fbd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e00fbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78e00fbd')) {
      api.createRecord('78e00fbd', component.options)
    } else {
      api.reload('78e00fbd', component.options)
    }
    module.hot.accept("./BankAccounts.vue?vue&type=template&id=78e00fbd&scoped=true", function () {
      api.rerender('78e00fbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinancialManagementNew/BankAccounts.vue"
export default component.exports